export interface IDataLayerEvent {
	[key: string]: any;
}

export enum EAlgoliaManagerEventType {
	PRODUCT_ADD_TO_CART = 'addedToCartObjectIDsAfterSearch',
	PRODUCT_SUGGESTION_CLICK = 'clickedObjectIDsAfterSearch'
}

export enum EAlgoliaManagerEventName {
	PRODUCT_ADD_TO_CART = 'Product Add to cart after search',
	PRODUCT_SUGGESTION_CLICK = 'Clicked on product search hit after search'
}

export interface IAlgoliaEventData {
	[key: string]: any;
}
